import st from "lib/utils/index";
import BaseDecorator from "./BaseDecorator";

export default class CouponCodeDecorator extends BaseDecorator {
  static build(data = {}) {
    return new this({
      id: null,
      uuid: st.generateUuid(),
      name: null,
      total_stock_used: 0,
      total_stock_limit: null,
      ...data,
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/CouponCodeDecorator.js